module.exports = __webpack_public_path__ + "static/media/skycell.807810f9.png";